export default class NutriMail {

  static check_mail_interval = () => {
    return 30 * 1000
  };
  static max_file_size = () => {
    return 10 * 1000 * 1000
  };
}
